import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { VerifyEmailForm } from '../../../components/forms';
import { resendVerifyCode } from '../../../service/auth';
import {
  makeSelectAuthProceeding,
  makeSelectAuthError,
} from '../../../store/selectors';
import { verifyEmailInit, signOut } from '../../../store/actions/auth';

const VerifyEmail = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isProceeding = useSelector(makeSelectAuthProceeding());
  const authError = useSelector(makeSelectAuthError());
  const [error, setError] = useState(null);
  const [isSending, setIsSending] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleResendCode = async () => {
    setIsSending(true);
    setError('');
    setSuccess(false);

    try {
      await resendVerifyCode();
      setSuccess(true);
    } catch (err) {
      console.log('Error in resending code', err);
      setError('Something went wrong, please try again.');
    } finally {
      setIsSending(false);
    }
  };
  const handleSubmit = (data) => {
    setError('');
    dispatch(verifyEmailInit(data));
  };
  const handleReturnToSignIn = () => {
    dispatch(signOut());
    history.push('/sign-in');
  };

  useEffect(() => setError(authError), [authError]);
  useEffect(() => {
    let to;
    if (success) {
      to = setTimeout(() => setSuccess(false), 3000);
    }

    return () => to && clearTimeout(to);
  }, [success]);

  return (
    <div className="w-1/3 m-auto p-6  rounded-2xl bg-white shadow-lg">
      <VerifyEmailForm
        error={error}
        isSubmitting={isProceeding}
        isResending={isSending}
        success={success}
        onSubmit={handleSubmit}
        onResendCode={handleResendCode}
        onReturn={handleReturnToSignIn}
      />
    </div>
  );
};

export default VerifyEmail;
